const uz = {
    meta: {
        title: "Markirovka kodi chekda 2026: kassa dasturi talablari",
        description:
            "1-iyuldan markirovka kodi onlayn-KKM chekida majburiy. Kassa dasturi uchun 5 ta texnik talab, moslashtirish narxi, muddati va tayyor bo'lmaslikning oqibati.",
        keywords: [
            "markirovka kodi chekda 2026",
            "raqamli markirovka O'zbekiston qoidalari",
            "onlayn kassa markirovka integratsiyasi",
            "do'kon uchun ombor dasturi markirovka",
            "markirovka skaner 2D kod",
            "markirovka qoidalarini buzish soliq riski",
        ],
    },
    h1: "Chekdagi markirovka kodi: do'kon dasturingiz 1-iyulga tayyormi",
    lead:
        "2026-yil 1-iyuldan markirovka qilingan tovar sotilganda uning kodi onlayn-kassa chekida aks etishi shart. Bu maqolada kassa va ombor dasturi bajarishi kerak bo'lgan beshta texnik talab, moslashtirish narxi va tayyorgarlik rejasini ko'rib chiqamiz.",
    category: "Qonun va muvofiqlik",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Savol oddiy ko'rinadi: chekka bitta qator qo'shish. Amalda esa bu kassa, ombor, hisob-faktura va soliq tizimini bitta zanjirga bog'lashni talab qiladi. Zanjirning bitta bo'g'ini ishlamasa, sotuv to'xtaydi.",
        },
        {
            type: "p",
            text:
                "Quyida do'kon egasi uchun texnik cheklist bor. Uni yetkazib beruvchingizga yuborib, har bir bandga «ha» yoki «yo'q» javobini yozma so'rang. Og'zaki va'da bu yerda ish bermaydi.",
        },

        { type: "h2", text: "1-iyuldan nima aniq o'zgaradi?" },
        {
            type: "p",
            text:
                "Vazirlar Mahkamasining 2025-yil 23-maydagi ПП-190 qaroriga ko'ra 2026-yil 1-iyuldan markirovka qilingan tovar sotilganda markirovka kodi onlayn-KKM chekida majburiy aks etishi shart. Shu sanadan markirovka qilinadigan mahsulot bilan ulgurji savdoda hisob-kitob ham faqat naqdsiz shaklda o'tkaziladi.",
        },
        {
            type: "p",
            text:
                "Markirovka ro'yxati kengayib bormoqda. Masalan, 2026-yil 1-iyundan kofe, sikoriy va ularning ekstraktlari majburiy raqamli markirovkaga kiritildi. Ya'ni bugun sizga tegishli bo'lmagan toifa ertaga tegishli bo'lishi mumkin — dastur tanlashda buni hisobga oling.",
        },
        {
            type: "p",
            text:
                "Nazorat ham o'zgardi. 2026-yil 1-yanvardan markirovka qoidalari buzilishini aniqlash bo'yicha tekshiruvlar masofadan, soliq organlari axborot tizimi orqali o'tkaziladi; nazorat uchun Hududlararo soliq inspeksiyasi tashkil etildi. 1-sentyabrdan esa buzilish «yuqori» soliq riski omili hisoblanadi.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Kassa dasturingiz tayyormi: beshta tekshiruv" },
        {
            type: "p",
            text:
                "Quyidagi jadval — yetkazib beruvchiga yuboriladigan so'rov varaqasi. Har bir qatorga javob oling va javobni saqlang.",
        },
        {
            type: "table",
            head: ["Talab", "Nima tekshiriladi", "Javob bo'lmasa nima bo'ladi"],
            rows: [
                [
                    "2D skaner qo'llab-quvvatlash",
                    "Kassa dasturi Data Matrix kodini o'qiy oladimi, oddiy shtrix-koddan farqlay oladimi",
                    "Kassir kodni qo'lda kiritishga urinadi, navbat va xatolik o'sadi",
                ],
                [
                    "Kodni fiskal chekka uzatish",
                    "Kod chek qatoriga tushadimi va fiskal operatorga to'g'ri yetib boradimi",
                    "Chek qonuniy talabga javob bermaydi",
                ],
                [
                    "Qoldiqni kod darajasida yuritish",
                    "Ombor «100 dona» emas, har bir kodni alohida biriktira oladimi",
                    "Sotilgan tovar qoldiqda qoladi, inventarizatsiya mos kelmaydi",
                ],
                [
                    "ESF bilan moslik",
                    "Kirim hujjatidagi kodlar bilan sotuvdagi kodlar solishtiriladimi",
                    "Kirim va chiqim orasida ko'rinmaydigan farq to'planadi",
                ],
                [
                    "Offline rejim",
                    "Internet uzilganda sotuv davom etadimi va ulanish tiklanganda ma'lumot yuborlandimi",
                    "Aloqa uzilgan paytda kassa to'xtaydi",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Amalda eng ko'p muammo uchinchi va to'rtinchi qatorda chiqadi. Ko'p do'konlarda kassa dasturi kodni chekka uzatadi, lekin omborda qoldiq baribir dona bo'yicha yuriladi. Shunda hisobot ikkiga bo'linadi va farqni oy oxirida qo'lda tuzatishga to'g'ri keladi.",
        },

        { type: "h2", text: "Markirovka kodi qanday yo'l bosadi" },
        {
            type: "p",
            text:
                "Jarayonni bir marta tushunib olsangiz, dastur tanlash osonlashadi. Kod tovar qadog'idagi Data Matrix belgisidan boshlanadi va bir necha bo'g'indan o'tadi.",
        },
        {
            type: "ol",
            items: [
                "Kassir 2D skaner bilan qadoqdagi Data Matrix kodini o'qiydi.",
                "Kassa dasturi kodni chek qatoriga biriktiradi va uni fiskal ma'lumotlar operatoriga uzatadi.",
                "Operator ma'lumotni soliq axborot tizimiga yetkazadi.",
                "Shu bilan parallel ravishda kod ombor qoldig'idan chiqariladi.",
                "Kirim tomonida esa o'sha kod elektron hisob-faktura bilan solishtiriladi.",
            ],
        },
        {
            type: "p",
            text:
                "Muhimi shu: sotuv va ombor bitta bazada bo'lishi kerak. Ikki alohida dastur ishlatilsa, har bir kod ikki marta kiritiladi va farq muqarrar paydo bo'ladi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Ombor qoldig'i endi kod darajasida" },
        {
            type: "p",
            text:
                "Bu eng ko'p mehnat talab qiladigan qism. Ilgari qoldiq artikul bo'yicha yuritilardi: «shampun, 120 dona». Endi har bir dona o'z kodiga ega bo'ladi va tizim aynan qaysi kod sotilganini bilishi kerak.",
        },
        {
            type: "p",
            text:
                "O'tish paytida omborda allaqachon turgan tovarni qayta hisoblash kerak bo'ladi. Mehnat hajmini o'lchash oson: bitta pozitsiyani skanerlash o'rtacha 5–10 soniya oladi. 3 000 pozitsiyali do'kon uchun bu ikki xodimning taxminan bir kunlik ishi. 20 000 pozitsiyali ombor uchun esa bir haftalik reja kerak bo'ladi.",
        },
        {
            type: "callout",
            text:
                "Qayta hisoblashni 1-iyulga qoldirmang. O'sha kuni ish boshlansa, do'kon bir necha kun to'xtaydi. Uni oldindan, bosqichma-bosqich, toifalar bo'yicha qiling.",
        },
        {
            type: "p",
            text:
                "Yana bir jihat: kod darajasidagi hisob faqat talab emas, u sizga ham foyda beradi. Qaysi partiya qachon kelgani, qancha turgani va qayerda yo'qolgani birinchi marta aniq ko'rinadi. Ko'p do'konlarda aynan shu ma'lumot muddati o'tayotgan tovarni oldindan aniqlash imkonini beradi.",
        },

        { type: "h2", text: "Internet o'chsa, kassa to'xtaydimi?" },
        {
            type: "p",
            text:
                "Bu savol deyarli har uchrashuvda beriladi va u o'rinli. Aloqa uzilishi O'zbekistonda hali ham odatiy hol, ayniqsa viloyat do'konlarida.",
        },
        {
            type: "p",
            text:
                "To'g'ri qurilgan yechimda kassa dasturi mahalliy bazaga yozadi va ulanish tiklanganda ma'lumotni navbat bilan yuboradi. Ya'ni sotuv davom etadi, uzatish esa kechikadi. Bulutga to'liq bog'liq yechimlarda esa aloqa uzilishi kassaning to'xtashini anglatadi. Dastur tanlashda buni birinchi navbatda so'rang.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Bitta savdo nuqtasini moslashtirish qancha turadi?" },
        {
            type: "p",
            text:
                "Narx hozirgi holatingizga bog'liq. Quyidagi jadval uchta tipik stsenariyni ko'rsatadi.",
        },
        {
            type: "table",
            head: ["Stsenariy", "Ish hajmi", "Muddat", "Narx"],
            rows: [
                [
                    "Dasturda markirovka moduli bor, sozlash kerak",
                    "Sozlash, skaner ulash, kassirlarni o'qitish",
                    "1–2 hafta",
                    "Yetkazib beruvchi tarifi + uskuna",
                ],
                [
                    "Mavjud dasturga modul qo'shish kerak",
                    "Kod o'qish, chekka uzatish, qoldiqni kod darajasiga o'tkazish",
                    "4–8 hafta",
                    "15 mln so'mdan",
                ],
                [
                    "Sotuv va ombor uchun yangi tizim",
                    "Bo'lim darajasidagi tizim, integratsiyalar bilan",
                    "3–5 oy",
                    "45 mln so'mdan",
                ],
                [
                    "Bir necha filial, yagona ombor va moliya",
                    "ERP konturi, 1C bilan integratsiya",
                    "4–8 oy",
                    "40 mln so'mdan",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Narxga kirmaydigan qismlar: 2D skanerlar (har bir kassa uchun alohida), kassa uskunasini yangilash, internet kanalini zaxiralash, kassirlarni o'qitishga ketadigan ish vaqti va ishga tushgandan keyingi qo'llab-quvvatlash — oyiga 3,5 mln so'mdan.",
        },

        { type: "h2", text: "Qaytim qanday hisoblanadi?" },
        {
            type: "p",
            text:
                "Markirovka loyihasining qaytimi ikki manbadan yig'iladi: qo'l mehnatining qisqarishi va yo'qotilgan tovarning kamayishi. Ikkalasini ham o'z raqamingiz bilan hisoblang.",
        },
        {
            type: "ol",
            items: [
                "Inventarizatsiya va qoldiqni tekislashga oyiga necha soat ketadi? Aytaylik, 40 soat.",
                "Soat tannarxi: oylik maosh ÷ 168. 7 mln so'mlik maosh uchun taxminan 41 700 so'm.",
                "40 × 41 700 ≈ 1,7 mln so'm — qo'lda hisoblashning oylik narxi.",
                "Ikkinchi manba: yo'qolgan va muddati o'tgan tovar. Oylik aylanmaning 1% i ham 200 mln so'mlik aylanmada 2 mln so'm degani.",
                "Kod darajasidagi hisob shu yo'qotishning yarmini oldini olsa, oyiga 1 mln so'm qo'shiladi.",
                "Jami taxminan 2,7 mln so'm / oy. 15 mln so'mlik loyiha shu hisobda 6 oyga yaqin muddatda qaytadi.",
            ],
        },
        {
            type: "p",
            text:
                "O'z raqamlaringizni qo'ying. Aylanmangiz kichik bo'lsa yoki inventarizatsiya allaqachon avtomatlashtirilgan bo'lsa, natija boshqacha chiqadi — va bu ham foydali javob.",
        },

        { type: "h2", text: "Tayyor bo'lmaslikning narxi" },
        {
            type: "p",
            text:
                "Bu ro'yxatdagi har bir band amaliyotdan olingan. Ularning umumiy xususiyati shu: hech biri bir kunda hal bo'lmaydi va hammasi sotuvga to'g'ridan-to'g'ri ta'sir qiladi.",
        },
        {
            type: "list",
            items: [
                "Chekda kod bo'lmasa, markirovka qilingan tovarni qonuniy sotib bo'lmaydi — qoldiq omborda qoladi va pul muzlaydi.",
                "1-sentyabrdan markirovka qoidalarini buzish «yuqori» soliq riski omili hisoblanadi; bu kompaniya profiliga ta'sir qiladi.",
                "Tekshiruv masofadan o'tkazilgani uchun xatolik inspektor kelishini kutmaydi — u ma'lumot mos kelmagan zahoti ko'rinadi.",
                "Shoshilinch moslashtirish qimmatroq: iyun oyida ishlab chiquvchilar navbati to'ladi va muddat qisqaradi.",
                "Kassada qo'lda kod kiritish navbat hosil qiladi va bitta xatolik butun chekni qayta rasmiylashtirishga olib keladi.",
            ],
        },

        { type: "h2", text: "Bu loyiha qachon sizga mos emas" },
        {
            type: "list",
            items: [
                "Sotayotgan tovaringizning birortasi markirovka ro'yxatiga kirmasa — hozircha skaner ham, yangi dastur ham kerak emas.",
                "Bitta kassali kichik do'kon bo'lsa va yetkazib beruvchingiz modulni tarif ichida bersa — alohida ishlab chiqish ortiqcha xarajat.",
                "Do'konni bir necha oyda yopish yoki formatni o'zgartirish rejangiz bo'lsa — katta tizimga kirishmang.",
                "Ichkarida kodlar bilan ishlashni nazorat qiladigan mas'ul bo'lmasa — dastur to'g'ri ishlaydi, jarayon esa buziladi.",
                "Qoldiqlar hali tartibga solinmagan bo'lsa — avval inventarizatsiya, keyin avtomatlashtirish. Teskarisi ishlamaydi.",
            ],
        },

        { type: "h2", text: "To'rt haftalik tayyorgarlik rejasi" },
        {
            type: "ol",
            items: [
                "1-hafta: sotayotgan tovarlaringizdan qaysilari markirovka ro'yxatiga kirishini aniqlang va ro'yxatni yozib qo'ying.",
                "2-hafta: yuqoridagi beshta talab bo'yicha yetkazib beruvchidan yozma javob oling.",
                "3-hafta: skaner va kassa uskunasini tekshiring, zarur bo'lsa buyurtma bering; internet kanalini zaxiralang.",
                "4-hafta: qoldiqni toifalar bo'yicha qayta hisoblashni boshlang va kassirlar bilan sinov sotuvini o'tkazing.",
            ],
        },
        {
            type: "p",
            text:
                "Reja oddiy ko'rinadi, lekin uni ikkinchi haftadan boshlagan do'konlar odatda muddatga ulgurmaydi. Sabab bitta: yetkazib beruvchidan javob olish va uskuna yetkazib berish o'zi bir necha hafta oladi.",
        },
    ],

    faq: [
        {
            q: "Markirovka kodi chekda qachondan majburiy bo'ladi?",
            a: "2026-yil 1-iyuldan. ПП-190 qaroriga ko'ra markirovka qilingan tovar sotilganda uning kodi onlayn-KKM chekida aks etishi shart. Bu kassaga 2D skaner ulashni va kassa dasturining kodni fiskal chekka uzata olishini talab qiladi. Eski dasturlarning ko'pchiligida bunday funksiya yo'q, shuning uchun tekshiruvni oldindan o'tkazing.",
        },
        {
            q: "Oddiy shtrix-kod skaneri yetadimi?",
            a: "Yo'q. Markirovka kodi Data Matrix formatida bo'ladi — bu ikki o'lchovli belgi va uni chiziqli shtrix-kod skaneri o'qiy olmaydi. Har bir kassa uchun 2D skaner kerak bo'ladi. Xarid qilishdan oldin skaner modeli sizning kassa dasturingiz bilan mos kelishini yetkazib beruvchidan tasdiqlatib oling.",
        },
        {
            q: "Qaysi tovarlar markirovka qilinadi?",
            a: "Ro'yxat bosqichma-bosqich kengaymoqda va ПП-190 qarori bilan belgilanadi. Masalan, 2026-yil 1-iyundan unga kofe, sikoriy va ularning ekstraktlari qo'shildi. Ayni paytdagi to'liq ro'yxatni rasmiy manbadan tekshiring va dastur tanlashda kelgusi toifalar qo'shilishini ham hisobga oling. Bugun tegishli bo'lmagan toifa ertaga ro'yxatga kirishi mumkin, shuning uchun dastur kengaya oladigan bo'lsin.",
        },
        {
            q: "Ombor qoldig'ini qayta hisoblash qancha vaqt oladi?",
            a: "Bitta pozitsiyani skanerlash o'rtacha 5–10 soniya oladi. 3 000 pozitsiyali do'kon uchun bu ikki xodimning taxminan bir kunlik ishi, 20 000 pozitsiyali ombor uchun esa bir haftalik reja kerak. Ishni toifalar bo'yicha bosqichma-bosqich qiling, aks holda do'kon bir necha kun to'xtaydi.",
        },
        {
            q: "Internet uzilganda kassa ishlaydimi?",
            a: "To'g'ri qurilgan yechimda ha. Kassa dasturi mahalliy bazaga yozadi va aloqa tiklanganda ma'lumotni navbat bilan yuboradi, sotuv esa to'xtamaydi. To'liq bulutga bog'liq yechimlarda aloqa uzilishi kassaning to'xtashini anglatadi. Dastur tanlashda offline rejim borligini birinchi navbatda so'rang va uni shartnomada yozib qo'ying. Viloyat do'konlari uchun bu band eng muhimi.",
        },
        {
            q: "Moslashtirish qancha turadi?",
            a: "Agar dasturda markirovka moduli allaqachon bo'lsa, sozlash va uskuna bilan cheklanasiz. Mavjud dasturga modul qo'shish 4–8 hafta oladi va 15 mln so'mdan boshlanadi. Sotuv va ombor uchun yangi tizim 45 mln so'mdan, filiallar uchun ERP konturi esa 40 mln so'mdan boshlanadi.",
        },
    ],

    cta: {
        h: "Kassa dasturingiz 1-iyulga tayyormi — bepul tekshiramiz",
        p:
            "Hozirgi dasturingizni, tovar toifalaringizni va kassa uskunangizni ko'rib chiqamiz, so'ng beshta talab bo'yicha aniq javob beramiz. Tayyor bo'lsangiz, ortiqcha ish taklif qilmaymiz.",
        button: "Bepul tekshiruv so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/markirovka-kodi-chekda-cover.webp",
            alt: "Kassada Data Matrix markirovka kodini skanerlash va uning chek qatoriga tushishi",
            caption: "Kod qadoqdan chekka: jarayon shu bitta harakatdan boshlanadi",
            prompt:
                "Retail checkout counter close-up: a handheld 2D barcode scanner reading a Data Matrix code on a product package, POS screen in the background showing the scanned marking code added to a receipt line; realistic product photography style, soft daylight, neutral shop interior, no readable brand names, 16:9",
        },
        {
            src: "/assets/img/blog/markirovka-kodi-chekda-sxema.webp",
            alt: "Markirovka kodining skanerdan kassa, fiskal operator va soliq tizimigacha bo'lgan yo'li",
            caption: "Zanjirning bitta bo'g'ini ishlamasa, butun sotuv to'xtaydi",
            prompt:
                "Technical data-flow diagram: product with Data Matrix code to 2D scanner to POS / online cash register to fiscal data operator to tax information system, with a parallel branch to warehouse stock ledger and e-invoice; clean isometric-lite line style, blue and green accents, labeled boxes, 16:9",
        },
        {
            src: "/assets/img/projects/sts-market.webp",
            alt: "STS Market savdo tizimi interfeysi — mahsulot kartochkasi va qoldiq hisobi",
            caption: "Kod darajasidagi hisob uchun tovar kartochkasi shunday ko'rinishda bo'ladi",
        },
        {
            src: "/assets/img/blog/markirovka-kodi-chekda-cheklist.webp",
            alt: "Kassa dasturi uchun markirovka talablari cheklisti — beshta band",
            caption: "Cheklistni yetkazib beruvchiga yuboring va javobni yozma oling",
            prompt:
                "Checklist illustration styled as a UI panel: five requirement rows with green check and red cross states — 2D scanner support, marking code in receipt, e-invoice match, code-level stock tracking, offline mode; minimal light interface, blue accent, no logos, 4:3",
        },
    ],

    relatedServices: ["erp-tizimlar", "biznes-avtomatlashtirish", "desktop-ilova"],
    relatedPosts: ["biznesni-raqamlashtirish-talablari-2026", "ulgurji-savdo-naqdsiz-hisob-kitob", "shaxsiy-malumotlar-qonuni-sayt"],
};

const ru = {
    meta: {
        title: "Код маркировки в чеке 2026: требования к программе кассы",
        description:
            "С 1 июля код маркировки обязателен в чеке онлайн-ККМ. Пять технических требований к кассовой программе, стоимость и срок доработки, цена неготовности.",
        keywords: [
            "код маркировки в чеке онлайн-ККМ 2026",
            "маркировка товаров розница Узбекистан",
            "интеграция онлайн-ККМ с системой маркировки",
            "складская программа с поддержкой маркировки",
            "сканер Data Matrix для кассы",
            "нарушение маркировки налоговый риск",
        ],
    },
    h1: "Код маркировки в чеке: готова ли программа вашего магазина к 1 июля",
    lead:
        "С 1 июля 2026 года при продаже маркированного товара его код должен отражаться в чеке онлайн-кассы. Разбираем пять технических требований к кассовой и складской программе, стоимость доработки и план подготовки.",
    category: "Закон и комплаенс",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Задача выглядит простой: добавить строку в чек. На практике она требует связать в одну цепочку кассу, склад, счёт-фактуру и налоговую систему. Если ломается одно звено, останавливается продажа.",
        },
        {
            type: "p",
            text:
                "Ниже — технический чек-лист для владельца магазина. Отправьте его поставщику программы и попросите письменный ответ «да» или «нет» по каждому пункту. Устные обещания здесь не работают.",
        },

        { type: "h2", text: "Что именно меняется с 1 июля?" },
        {
            type: "p",
            text:
                "По постановлению ПП-190 от 23 мая 2025 года с 1 июля 2026 года при продаже маркированного товара код маркировки должен отражаться в чеке онлайн-ККМ. С этой же даты расчёты в оптовой торговле маркируемой продукцией проводятся только в безналичной форме.",
        },
        {
            type: "p",
            text:
                "Перечень маркируемых товаров расширяется. Например, с 1 июня 2026 года в обязательную цифровую маркировку включены кофе, цикорий и их экстракты. То есть категория, которая сегодня вас не касается, завтра может попасть в список — учитывайте это при выборе программы.",
        },
        {
            type: "p",
            text:
                "Изменился и контроль. С 1 января 2026 года проверки по выявлению нарушений маркировки проводятся дистанционно, через информационную систему налоговых органов; для контроля создана Межрегиональная налоговая инспекция. А с 1 сентября нарушение считается фактором «высокого» налогового риска.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Готова ли ваша касса: пять проверок" },
        {
            type: "p",
            text:
                "Таблица ниже — это анкета для поставщика программы. Получите ответ по каждой строке и сохраните его.",
        },
        {
            type: "table",
            head: ["Требование", "Что проверяем", "Что будет, если нет"],
            rows: [
                [
                    "Поддержка 2D-сканера",
                    "Умеет ли программа читать код Data Matrix и отличать его от обычного штрихкода",
                    "Кассир вводит код вручную, очередь и число ошибок растут",
                ],
                [
                    "Передача кода в фискальный чек",
                    "Попадает ли код в строку чека и корректно ли уходит фискальному оператору",
                    "Чек не соответствует требованию закона",
                ],
                [
                    "Учёт остатка на уровне кода",
                    "Может ли склад привязывать каждый код отдельно, а не вести «100 штук»",
                    "Проданный товар остаётся в остатке, инвентаризация не сходится",
                ],
                [
                    "Сверка с ЭСФ",
                    "Сопоставляются ли коды из приходного документа с кодами в продаже",
                    "Между приходом и расходом копится невидимое расхождение",
                ],
                [
                    "Офлайн-режим",
                    "Продолжается ли продажа при обрыве связи и уходят ли данные после восстановления",
                    "Касса останавливается вместе с интернетом",
                ],
            ],
        },
        {
            type: "p",
            text:
                "На практике чаще всего спотыкаются на третьей и четвёртой строке. Во многих магазинах программа передаёт код в чек, но остаток на складе по-прежнему ведётся в штуках. Тогда отчётность распадается надвое, и разницу приходится править вручную в конце месяца.",
        },

        { type: "h2", text: "Какой путь проходит код маркировки" },
        {
            type: "p",
            text:
                "Если один раз разобраться в процессе, выбирать программу становится проще. Код начинается с метки Data Matrix на упаковке и проходит несколько звеньев.",
        },
        {
            type: "ol",
            items: [
                "Кассир считывает код Data Matrix с упаковки 2D-сканером.",
                "Кассовая программа привязывает код к строке чека и передаёт его оператору фискальных данных.",
                "Оператор доставляет данные в информационную систему налоговых органов.",
                "Параллельно код списывается со складского остатка.",
                "На стороне прихода этот же код сверяется с электронной счёт-фактурой.",
            ],
        },
        {
            type: "p",
            text:
                "Ключевое здесь одно: продажи и склад должны жить в одной базе. Если используются две отдельные программы, каждый код вводится дважды, и расхождение появляется неизбежно.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Остаток теперь ведётся на уровне кода" },
        {
            type: "p",
            text:
                "Это самая трудоёмкая часть. Раньше остаток вёлся по артикулу: «шампунь, 120 штук». Теперь у каждой единицы свой код, и система должна знать, какой именно код был продан.",
        },
        {
            type: "p",
            text:
                "При переходе придётся пересчитать товар, который уже лежит на складе. Объём работы измеряется просто: сканирование одной позиции занимает в среднем 5–10 секунд. Для магазина на 3 000 позиций это примерно день работы двух сотрудников, для склада на 20 000 позиций нужен план на неделю.",
        },
        {
            type: "callout",
            text:
                "Не откладывайте пересчёт на 1 июля. Если начать в этот день, магазин встанет на несколько суток. Делайте заранее и по категориям.",
        },

        { type: "h2", text: "Остановится ли касса, если пропадёт интернет?" },
        {
            type: "p",
            text:
                "Этот вопрос задают почти на каждой встрече, и он справедлив. Обрывы связи в Узбекистане пока обычное дело, особенно в областных магазинах.",
        },
        {
            type: "p",
            text:
                "В правильно построенном решении кассовая программа пишет в локальную базу и отправляет данные очередью после восстановления связи. То есть продажа продолжается, а передача просто задерживается. В решениях, полностью завязанных на облако, обрыв связи означает остановку кассы. Спрашивайте об этом в первую очередь.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Сколько стоит подготовить одну торговую точку?" },
        {
            type: "p",
            text:
                "Цена зависит от того, с чего вы стартуете. В таблице — три типичных сценария и вариант для сети.",
        },
        {
            type: "table",
            head: ["Сценарий", "Объём работ", "Срок", "Цена"],
            rows: [
                [
                    "В программе уже есть модуль маркировки, нужна настройка",
                    "Настройка, подключение сканера, обучение кассиров",
                    "1–2 недели",
                    "Тариф поставщика + оборудование",
                ],
                [
                    "Нужно дописать модуль в существующую программу",
                    "Чтение кода, передача в чек, перевод остатка на уровень кода",
                    "4–8 недель",
                    "от 15 млн сум",
                ],
                [
                    "Новая система для продаж и склада",
                    "Система уровня отдела вместе с интеграциями",
                    "3–5 месяцев",
                    "от 45 млн сум",
                ],
                [
                    "Несколько филиалов, общий склад и финансы",
                    "Контур ERP, интеграция с 1С",
                    "4–8 месяцев",
                    "от 40 млн сум",
                ],
            ],
        },
        {
            type: "p",
            text:
                "В цену не входят: 2D-сканеры на каждую кассу, обновление кассового оборудования, резервный интернет-канал, рабочее время на обучение кассиров и поддержка после запуска — от 3,5 млн сум в месяц.",
        },

        { type: "h2", text: "Как считать окупаемость?" },
        {
            type: "p",
            text:
                "Окупаемость проекта по маркировке складывается из двух источников: сокращение ручной работы и снижение потерь товара. Посчитайте оба на своих цифрах.",
        },
        {
            type: "ol",
            items: [
                "Сколько часов в месяц уходит на инвентаризацию и выравнивание остатков? Допустим, 40 часов.",
                "Себестоимость часа: оклад ÷ 168. При окладе 7 млн сум это примерно 41 700 сум.",
                "40 × 41 700 ≈ 1,7 млн сум — месячная цена ручного пересчёта.",
                "Второй источник: потери и просрочка. Даже 1% месячного оборота — при обороте 200 млн сум это 2 млн сум.",
                "Если учёт на уровне кода предотвращает половину этих потерь, добавляется ещё 1 млн сум в месяц.",
                "Итого около 2,7 млн сум в месяц. Проект за 15 млн сум при таком расчёте окупается примерно за 6 месяцев.",
            ],
        },
        {
            type: "p",
            text:
                "Подставьте свои числа. Если оборот небольшой или инвентаризация уже автоматизирована, результат будет другим — и это тоже полезный ответ.",
        },

        { type: "h2", text: "Цена неготовности" },
        {
            type: "list",
            items: [
                "Без кода в чеке маркированный товар нельзя продать легально — остаток лежит на складе, деньги заморожены.",
                "С 1 сентября нарушение правил маркировки считается фактором «высокого» налогового риска и влияет на профиль компании.",
                "Проверка проводится дистанционно, поэтому ошибка не ждёт приезда инспектора — она видна в момент расхождения данных.",
                "Срочная доработка дороже: в июне очередь у разработчиков заполнена, а сроки сжаты.",
                "Ручной ввод кода на кассе создаёт очередь, а одна ошибка приводит к переоформлению всего чека.",
            ],
        },

        { type: "h2", text: "Когда этот проект вам не нужен" },
        {
            type: "list",
            items: [
                "Ни один из ваших товаров не входит в перечень маркировки — ни сканер, ни новая программа пока не нужны.",
                "Небольшой магазин с одной кассой, а поставщик даёт модуль в рамках тарифа — отдельная разработка станет лишней тратой.",
                "Вы планируете закрыть точку или сменить формат в ближайшие месяцы — не начинайте крупный проект.",
                "В компании нет ответственного за работу с кодами — программа будет работать правильно, а процесс всё равно сломается.",
                "Остатки ещё не приведены в порядок — сначала инвентаризация, потом автоматизация. Наоборот не получается.",
            ],
        },

        { type: "h2", text: "План подготовки на четыре недели" },
        {
            type: "ol",
            items: [
                "Неделя 1: определите, какие из ваших товаров попадают в перечень маркировки, и зафиксируйте список.",
                "Неделя 2: получите от поставщика письменный ответ по пяти требованиям выше.",
                "Неделя 3: проверьте сканеры и кассовое оборудование, при необходимости закажите; зарезервируйте интернет-канал.",
                "Неделя 4: начните пересчёт остатков по категориям и проведите тестовую продажу вместе с кассирами.",
            ],
        },
        {
            type: "p",
            text:
                "План выглядит простым, но магазины, начавшие со второй недели, обычно не укладываются в срок. Причина одна: ответ от поставщика и поставка оборудования сами по себе занимают несколько недель.",
        },
    ],

    faq: [
        {
            q: "С какого числа код маркировки обязателен в чеке?",
            a: "С 1 июля 2026 года. По постановлению ПП-190 при продаже маркированного товара его код должен отражаться в чеке онлайн-ККМ. Это требует подключения 2D-сканера и кассовой программы, умеющей передавать код в фискальный чек. У многих старых программ такой функции нет, поэтому проверку стоит провести заранее.",
        },
        {
            q: "Достаточно ли обычного сканера штрихкодов?",
            a: "Нет. Код маркировки имеет формат Data Matrix — это двумерная метка, и линейный сканер штрихкодов её не прочитает. На каждую кассу потребуется отдельный 2D-сканер. Перед покупкой подтвердите у поставщика программы, что выбранная модель сканера совместима с вашей кассой, и заложите срок поставки оборудования в план подготовки.",
        },
        {
            q: "Какие товары подлежат маркировке?",
            a: "Перечень расширяется поэтапно и определяется постановлением ПП-190. Например, с 1 июня 2026 года в него включены кофе, цикорий и их экстракты. Актуальный полный список сверяйте с официальным источником и при выборе программы закладывайте появление новых категорий. Категория, которая сегодня вас не касается, завтра может попасть в перечень.",
        },
        {
            q: "Сколько времени займёт пересчёт остатков?",
            a: "Сканирование одной позиции занимает в среднем 5–10 секунд. Для магазина на 3 000 позиций это примерно день работы двух сотрудников, для склада на 20 000 позиций понадобится план на неделю. Делайте пересчёт поэтапно по категориям, иначе точка встанет на несколько суток.",
        },
        {
            q: "Будет ли работать касса без интернета?",
            a: "В правильно построенном решении да. Программа пишет в локальную базу и отправляет данные очередью после восстановления связи, а продажа не прерывается. В решениях, полностью зависящих от облака, обрыв связи означает остановку кассы. Наличие офлайн-режима спрашивайте в первую очередь и фиксируйте его в договоре. Для областных точек этот пункт самый важный.",
        },
        {
            q: "Сколько стоит доработка?",
            a: "Если модуль маркировки уже есть в программе, вы ограничитесь настройкой и оборудованием. Дописать модуль в существующую программу — 4–8 недель и от 15 млн сум. Новая система для продаж и склада начинается от 45 млн сум, контур ERP для сети — от 40 млн сум.",
        },
    ],

    cta: {
        h: "Бесплатно проверим готовность вашей кассовой программы",
        p:
            "Посмотрим текущую программу, категории товара и кассовое оборудование, затем дадим конкретный ответ по пяти требованиям. Если вы уже готовы, лишних работ предлагать не станем.",
        button: "Запросить проверку",
    },

    images: [
        {
            src: "/assets/img/blog/markirovka-kodi-chekda-cover.webp",
            alt: "Сканирование кода маркировки Data Matrix на кассе и его отражение в строке чека",
            caption: "От упаковки до чека: процесс начинается с одного движения сканера",
            prompt:
                "Retail checkout counter close-up: a handheld 2D barcode scanner reading a Data Matrix code on a product package, POS screen in the background showing the scanned marking code added to a receipt line; realistic product photography style, soft daylight, neutral shop interior, no readable brand names, 16:9",
        },
        {
            src: "/assets/img/blog/markirovka-kodi-chekda-sxema.webp",
            alt: "Путь кода маркировки от сканера до кассы, фискального оператора и налоговой системы",
            caption: "Ломается одно звено — останавливается вся продажа",
            prompt:
                "Technical data-flow diagram: product with Data Matrix code to 2D scanner to POS / online cash register to fiscal data operator to tax information system, with a parallel branch to warehouse stock ledger and e-invoice; clean isometric-lite line style, blue and green accents, labeled boxes, 16:9",
        },
        {
            src: "/assets/img/projects/sts-market.webp",
            alt: "Интерфейс торговой системы STS Market — карточка товара и учёт остатков",
            caption: "Так выглядит карточка товара, пригодная для учёта на уровне кода",
        },
        {
            src: "/assets/img/blog/markirovka-kodi-chekda-cheklist.webp",
            alt: "Чек-лист требований к кассовой программе по маркировке — пять пунктов",
            caption: "Отправьте чек-лист поставщику и получите ответ письменно",
            prompt:
                "Checklist illustration styled as a UI panel: five requirement rows with green check and red cross states — 2D scanner support, marking code in receipt, e-invoice match, code-level stock tracking, offline mode; minimal light interface, blue accent, no logos, 4:3",
        },
    ],

    relatedServices: ["erp-tizimlar", "biznes-avtomatlashtirish", "desktop-ilova"],
    relatedPosts: ["biznesni-raqamlashtirish-talablari-2026", "ulgurji-savdo-naqdsiz-hisob-kitob", "shaxsiy-malumotlar-qonuni-sayt"],
};

const content = { uz, ru };

export default content;
